/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_CervicalInputs */

const en_us2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neck`)
};

const pt_br2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const es_419_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuello`)
};

const pt_pt2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const fr_fr2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cou`)
};

const de_de2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacken`)
};

const it_it2_profile_editors_pain_area_cervical = /** @type {(inputs: Profile_Editors_Pain_Area_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collo`)
};

/**
* | output |
* | --- |
* | "Neck" |
*
* @param {Profile_Editors_Pain_Area_CervicalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_cervical = /** @type {((inputs?: Profile_Editors_Pain_Area_CervicalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_CervicalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_cervical(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_cervical(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_cervical(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_cervical(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_cervical(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_cervical(inputs)
	return en_us2_profile_editors_pain_area_cervical(inputs)
});
export { profile_editors_pain_area_cervical as "profile-editors.pain_area_cervical" }